import { render, staticRenderFns } from "./PlansPlusIcon.vue?vue&type=template&id=622c03b2&"
import script from "./PlansPlusIcon.vue?vue&type=script&lang=ts&"
export * from "./PlansPlusIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports